// @flow weak

import {GET, POST, PUT} from '../helpers/request';
import {ADD as NOTIFICATION} from './notification';

export const GET_REQUEST = '@userView/GET_REQUEST';
export const GET_SUCCESS = '@userView/GET_SUCCESS';
export const GET_FAILURE = '@userView/GET_FAILURE';

export const UPDATE_REQUEST = '@userView/UPDATE_REQUEST';
export const UPDATE_SUCCESS = '@userView/UPDATE_SUCCESS';
export const UPDATE_FAILURE = '@userView/UPDATE_FAILURE';

export const CREATE_REQUEST = '@userView/CREATE_REQUEST';
export const CREATE_SUCCESS = '@userView/CREATE_SUCCESS';
export const CREATE_FAILURE = '@userView/CREATE_FAILURE';

export const ACTIVATION_REQUEST = '@userView/ACTIVATION_REQUEST';
export const ACTIVATION_SUCCESS = '@userView/ACTIVATION_SUCCESS';
export const ACTIVATION_FAILURE = '@userView/ACTIVATION_FAILURE';

export const RESET = '@userView/RESET';
export const CLEAR = '@userView/CLEAR';

const userRequest = () => ({
  type: GET_REQUEST,
});

const userSuccess = user => ({
  type: GET_SUCCESS,
  user,
});

const userFailure = error => ({
  type: GET_FAILURE,
  error,
});

const userUpdateRequest = () => ({
  type: UPDATE_REQUEST,
});

const userUpdateSuccess = user => ({
  type: UPDATE_SUCCESS,
  user,
  [NOTIFICATION]: {
    message: 'Användare uppdaterad',
  },
});

const userUpdateFailure = error => ({
  type: UPDATE_FAILURE,
  error,
});

const userCreateRequest = () => ({
  type: CREATE_REQUEST,
});

const userCreateSuccess = user => ({
  type: CREATE_SUCCESS,
  user,
  [NOTIFICATION]: {
    message: `Användare "${user.username}" skapad`,
  },
});

const userCreateFailure = error => ({
  type: CREATE_FAILURE,
  error,
});

const activationRequest = () => ({
  type: ACTIVATION_REQUEST,
});

const activationSuccess = () => ({
  type: ACTIVATION_SUCCESS,
  [NOTIFICATION]: {
    message: 'Aktiveringslänk skickad',
  },
});

const activationFailure = error => ({
  type: ACTIVATION_FAILURE,
  error,
});

export const fetchUser = id => async dispatch => {
  dispatch(userRequest());
  try {
    const user = await GET({endpoint: `/users/${id}`}, dispatch);
    dispatch(userSuccess(user));
  } catch (err) {
    dispatch(userFailure(err));
  }
};

export const updateUser = (id, body) => async dispatch => {
  dispatch(userUpdateRequest());
  try {
    const user = await PUT({
      endpoint: `/users/${id}`,
      body,
    }, dispatch);
    dispatch(userUpdateSuccess(user));
  } catch (err) {
    dispatch(userUpdateFailure(err));
  }
};

export const createUser = body => async dispatch => {
  dispatch(userCreateRequest());
  try {
    const user = await POST({
      endpoint: '/users',
      body,
    }, dispatch);
    dispatch(userCreateSuccess(user));
  } catch (err) {
    dispatch(userCreateFailure(err));
  }
};

export const sendActiviationLink = userId => async dispatch => {
  dispatch(activationRequest());
  try {
    await POST({
      endpoint: `/users/${userId}/activate`,
      expectBody: false,
    }, dispatch);
    dispatch(activationSuccess());
  } catch (err) {
    dispatch(activationFailure(err));
  }
};

export const clearUser = () => ({
  type: CLEAR,
});

export const reset = () => ({
  type: RESET,
});



// WEBPACK FOOTER //
// ./src/actions/userView.js